export default __webpack_public_path__ + "c2fe3cb2b7c746f7966a973d869d21c3.woff2";